import { render, staticRenderFns } from "./ProductStandardLayout.vue?vue&type=template&id=c9a663ce&scoped=true"
import script from "./ProductStandardLayout.vue?vue&type=script&lang=js"
export * from "./ProductStandardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a663ce",
  null
  
)

export default component.exports